import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  postWithdrawalApprovalWithdrawalRequestIDReject,
  type RejectWithdrawalRequest,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";
import { WITHDRAWAL_APPROVALS_QUERY_KEYS } from "WithdrawalApprovals/Api/Queries/queryKeys";

interface RejectWithdrawalParams {
  withdrawalRequestID: string;
  request: RejectWithdrawalRequest;
}

export function useRejectWithdrawalMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse(
      (params: RejectWithdrawalParams) =>
        postWithdrawalApprovalWithdrawalRequestIDReject(
          params.request,
          params.withdrawalRequestID,
        ),
      {
        translationPrefix: getResourcePath(
          Resources.ApiErrors.RejectWithdrawal,
        ),
      },
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: WITHDRAWAL_APPROVALS_QUERY_KEYS.all,
      });
    },
  });
}
